import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 1.875c.345 0 .625.28.625.625v.95a.625.625 0 1 1-1.25 0V2.5c0-.345.28-.625.625-.625ZM4.813 4.813a.625.625 0 0 1 .884 0l.57.57a.625.625 0 1 1-.884.884l-.57-.57a.625.625 0 0 1 0-.884Zm14.374 0a.625.625 0 0 1 0 .884l-.57.57a.625.625 0 0 1-.884-.884l.57-.57a.625.625 0 0 1 .884 0Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.675 12a6.325 6.325 0 1 1 8.85 5.8v1.8a2.525 2.525 0 0 1-5.05 0v-1.8a6.327 6.327 0 0 1-3.8-5.8ZM12 6.925a5.075 5.075 0 1 0 0 10.15 5.075 5.075 0 0 0 0-10.15Zm-1.275 11.271V19.6a1.275 1.275 0 1 0 2.55 0v-1.404a6.352 6.352 0 0 1-2.55 0Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M1.875 12c0-.345.28-.625.625-.625h.95a.625.625 0 1 1 0 1.25H2.5A.625.625 0 0 1 1.875 12Zm18.05 0c0-.345.28-.625.625-.625h.95a.625.625 0 1 1 0 1.25h-.95a.625.625 0 0 1-.625-.625Z"
    />
  </svg>
`;
